import {useSelector} from "react-redux";
import React from "react";
import InstitutionUserProgramDetails from "./InstitutionUserProgramDetails";
import SpeakerProgramDetails from "./SpeakerProgramDetails";

const MasterClassDetails = () => {
    const userType = useSelector((state) => state?.auth?.userData?.user_type);

    if (userType === 4) {
        return <SpeakerProgramDetails />
    }

    return <InstitutionUserProgramDetails />;
};

export default MasterClassDetails;